<template>
  <div>
    <input class="form-control" v-model="text" id="inputCity" list="my-list-id"/>
  	<datalist id="my-list-id">
  		<option v-for="item in items" :id="item.id" :key="item.id">{{ item.name }}</option>
  	</datalist>
  </div>
</template>

<script>
export default {
  props:['model','items'],
  name: 'AutocompleteLocal',
  data() {
    return{
      text:''
    }
  },
  methods:{

  },
  computed:{
    MyItems:{
      get() {
        return this.items
      }
    },
    MyModel:{
      get() {
        return this.model
      },
      set(val){
        this.$emit('update:model',val)
      }
    }
  },
      watch: {
      text(val){
        if(val.length > 0) {
        const value = this.MyItems.filter(item => item.name == val)
        console.log(val)
        if(value[0] != undefined){
          this.MyModel = value[0].id
        }
			}
      }
    }
}
</script>

<style>

</style>